define('LNRS/Adobe/AdobeScript',["jquery", 'eventManager'], function ($, eventManager) {
    function AdobeScript() { }
    AdobeScript.prototype.init = function init() {

        window.digitalData = window.digitalData || [];

        var isPreview = $("body").attr("is-preview");
        var environment = $("body").attr("environment");
        var isDevCD = isPreview === "False" && environment === "dev";
    
        //global registrations of analytics and gtm loading should only happen in preview and live mode
        if (typeof define === 'function' && define.amd && !isPageEditor()) {
            // load up adobe and trigger 'adobe-loaded' event in case any components need this
            if (isDevCD) {
                eventManager.trigger('adobe-loaded', window.digitalData);
            } else {
                require(['AdobeScript'], function (adobe) {
                    eventManager.trigger('adobe-loaded', window.digitalData);
                });
            }
        };
    }

    function isPageEditor() {
        if (typeof Sitecore == "undefined") {
            return false;
        }
        if (typeof Sitecore.PageModes == "undefined" || Sitecore.PageModes == null) {
            return false;
        }
        return Sitecore.PageModes.PageEditor != null;
    }

    return new AdobeScript();

});
